import { Popover } from '@mui/material';

import { usePopoverContext } from './context';

import type { PopoverProps } from '@mui/material';
import type { FC } from 'react';

export type MenuProviderProps = Omit<PopoverProps, 'open'>;

/**
 * provides management of the anchor element and open/close state of the PopoverDisplay
 * requires a <AnchorElement> to consume event handler
 *
 * @example
 * ```jsx
 *   <PopperProvider>
 *     <PopoverDisplay>
 *       <AnchorElement>
 *         <MenuItem>Profile</MenuItem>
 *       </AnchorElement>
 *       <AnchorElement>
 *         <MenuItem>My account</MenuItem>
 *       </AnchorElement>
 *       <AnchorElement>
 *         <MenuItem>Logout</MenuItem>
 *       </AnchorElement>
 *     </PopoverDisplay>
 *   </PopperProvider>
 * ```
 */

export const PopoverDisplay: FC<MenuProviderProps> = ({
  children,
  id: initialId,
  ...props
}) => {
  const {
    anchorEl,
    onClose,
    isOpen,
    id,
    // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
    handleToggle,
    // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
    handleOpen,
    // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
    handleClose,
    // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
    setAnchorEl,
    ...rest
  } = usePopoverContext();

  return (
    <Popover
      id={id ?? initialId}
      anchorEl={anchorEl}
      open={isOpen}
      onClose={onClose}
      {...rest}
      {...props}
    >
      {children}
    </Popover>
  );
};
